import { type FC } from "react";
import { MapPinned, TextSearch, Link as LinkIcon } from "lucide-react";

const PROPS = [
  {
    icon: MapPinned,
    title: "Start each matter with a complete estate record",
    description: "Client documents and key details arrive organized for review",
  },
  {
    icon: TextSearch,
    title: "Government-credentialed asset discovery",
    description: "Over $5M found for clients across 100+ financial sources",
  },
  {
    icon: LinkIcon,
    title: "Source-linked estate record that stays current",
    description: "See documents, tasks, and updates in one traceable view",
  },
] as const;

export const ValueProps: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      {PROPS.map(({ icon: Icon, title, description }) => (
        <div key={title} className="flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm border-[1.25px] border-primary bg-white p-2.5">
            <Icon className="h-5 w-5 text-brand" aria-hidden="true" />
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-sm font-medium text-primary">{title}</p>
            <p className="text-sm text-secondary">{description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
